<template>
<div class="row m-0 p-0 mb-1">
	<div class="row col-xl p-0 m-0 g-1">
		<div class="col-md-12">
			<half-line-vidget 
				name="Час зчитування"
				:value="postMetricTime(Post.metricsKeys.Eavg)"
			/>
		</div>
	</div>
	<div class="row col-xl d-none d-xl-block p-0 m-0 g-1">
		<div class="col-md-12">
			<half-line-vidget />
		</div>
	</div>
</div>

<div class="row m-0 p-0">
	<div class="row col-xxl p-0 m-0 mb-lg-1 g-1">
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<div class="half-transparent-border widget-7x5">
				<uprotect-chart
					:value="postMetricValue(Post.metricsKeys.Eavg, 2)"
				/>
			</div>
		</div>
		
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget
				title="Захисний потенціал, 10&nbsp;хв"
				class="h-100 w-100 m-0"
				style="margin: 0 !important;"
				:style="true ? '' : 'filter: grayscale(100%);'"
			>
				<div class="row m-0 mt-3 p-0">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">Emin</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ postMetricValue(Post.metricsKeys.Emin, 2) }}</div>
				</div>
				<div class="row m-0 p-0 my-2">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">Emax</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ postMetricValue(Post.metricsKeys.Emax, 2) }}</div>
				</div>
				<div class="row m-0 p-0">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">Eavg</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ postMetricValue(Post.metricsKeys.Eavg, 2) }}</div>
				</div>
			</tile-vidget>
		</div>

		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget
				title="Напруга батареї АКБ"
				class="h-100 w-100 m-0"
				style="margin: 0 !important;"
				:style="true ? '' : 'filter: grayscale(100%);'"
			>
				<div class="row m-0 mt-auto p-0">
					<div class="col mx-0 ps-2 text-center metric-value-text">
						<span class="fs-1">
							{{ postMetricValue(Post.metricsKeys.Vbat) + '\xa0В' }}
						</span>
					</div>
				</div>
				<div class="row m-0 mb-3 p-0 mt-auto">
				</div>
			</tile-vidget>
		</div>

		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget
				title="Стан зв'язку"
				class="h-100 w-100 m-0"
				style="margin: 0 !important;"
				:style="true ? '' : 'filter: grayscale(100%);'"
			>
				<div class="row m-0 mt-auto p-0">
					<div class="col mx-0 ps-2 text-center metric-value-text">
						<span class="fs-4 text-break text-wrap">
							{{ connectionQualityPromt( postMetricValue(Post.metricsKeys.connection_quality) ) }}
						</span>
					</div>
				</div>
				<div class="row m-0 mb-3 p-0 mt-auto">
				</div>
			</tile-vidget>
		</div>
	</div>
	<div class="row col-xxl d-none d-xxl-block p-0 m-0 mb-lg-1 g-1">
		<div class="col-12 m-0" style="margin-top: 1px !important;">
			<half-line-vidget/>
		</div>
		<div class="col-12">
			<half-line-vidget/>
		</div>
		<div class="col-12">
			<half-line-vidget/>
		</div>
		<div class="col-12">
			<half-line-vidget/>
		</div>
		<div class="col-12">
			<half-line-vidget/>
		</div>
	</div>
</div>

<div class="row m-0 p-0 g-1">
	<div class="col-12 col-xl order-2 order-xl-first m-0">
		<div
			class="half-transparent-border full-width-widget m-0 p-0"
			:style="{
				height: chartHeight + 'px', 
				width: !['xl', 'xxl'].includes(breakpoint) ? 'calc(100% - 3px)' : 'calc(100% - 1px)',
			}"
		>
			<post-potential-chart
				:postId="postId"
				:time-from="chartsPeriodFrom"
				:time-to="chartsPeriodTo"
				@loading="(v) => isChartLoading = v"
			/>
		</div>
	</div>

	<div
		class="col-12 order-1 order-xl-last m-0 p-0"
		:class="{
			'period-vidget-vertical': ['xl', 'xxl'].includes(breakpoint),
			'mb-1': !['xl', 'xxl'].includes(breakpoint),
		}"
	>
		<!-- Graph period choose -->
		<pick-period-vidget
			:tiles="new Array(
				['30 днів', 30],
				['90 днів', 90],
				['1 рік', 365],
				['2 роки', 365*2],
				['5 років', 365*5],)
			"
			:forward-backward-arrows="true"
			:layout="['xl', 'xxl'].includes(breakpoint) ? 'vertical' : 'horizontal'"
			:disabled="isChartLoading"
			@period="(timeFrom, timeTo, tileIndex) => {
				chartsPeriodFrom = timeFrom
				chartsPeriodTo = timeTo
			}"
		/>
	</div>
</div>
</template>


<script>
import HalfLineVidget from "@/components/Vidgets/HalfLineVidget.vue"
import TileVidget from "@/components/Vidgets/TileVidget"
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import UprotectChart from '@/components/Charts/UprotectChart.vue'
import PostPotentialChart from "@/components/Charts/PostPotentialChart.vue"
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
import { useAccontStore } from '@/stores/AccountStore'
import { usePostsStore } from '@/stores/PostsStore'
import { Post } from '@/models/post.js'
import {
	subtractHoursFromNowDate,
} from '@/helpers.js'


export default {
	inject: ['headerHeight'],

	components: {
		HalfLineVidget,
		TileVidget,
		PickPeriodVidget,
		UprotectChart,
		PostPotentialChart,
	},

	props: {
		postId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const { breakpoint } = useSizeBreakpoint()
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()

		return {
			breakpoint,
			Post,
			subtractHoursFromNowDate,
			accountStore,
			postsStore,
		}
	},

	data() {
		return {
			chartsPeriodFrom: new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 30)),
			chartsPeriodTo: new Date(),
			isChartLoading: true,
		}
	},

	created() {
	},

	methods: {
		postMetricValue(metricName, fixed=null) {
			let metric = this.post?.getMetric(metricName)

			if (metric === undefined) {
				return '-'
			}

			if (typeof metric == 'object') {
				if (fixed !== null) {
					metric = metric.value.toFixed(fixed)
				} else {
					metric = metric.value
				}
			}

			return metric
		},

		postMetricTime(metricName) {
			let metric = this.post?.getMetric(metricName)
			
			if (typeof metric == 'object') {
				return metric.time.toLocaleString()
			} else {
				return '-'
			}

		},

		connectionQualityPromt(qualityGrade) {
			if (qualityGrade >= 0 && qualityGrade <= 17) {
				return "Не задовільний"
			} else if (qualityGrade > 17 && qualityGrade <= 100) {
				return "Задовільний"
			} else {
				return `${qualityGrade}`
			}
		},
	},

	computed: {
		post() { return this.postsStore.post(this.postId); },

		chartHeight() {
			const	body = document.body,
					html = document.documentElement;
			const	docHeight = Math.max(body.scrollHeight, body.offsetHeight, 
					html.clientHeight, html.scrollHeight, html.offsetHeight);
			const chartHeight = docHeight - Number(this.headerHeight.replace(/[^0-9]/gi, '')) - 300
			if (chartHeight >= 300) {
				return chartHeight
			} else {
				return 300
			}
		},
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style scoped>
.period-vidget-vertical {
	flex: 0 0 auto; /* Забороняє розтягуватись */
	/* min-width: 9em;
	max-width: 11em; */
	width: 10em;
}
</style>